import { WatchlistsStore, WATCHLISTS_STORE_NAME } from './store';
import { Dispatch } from '@reduxjs/toolkit';
import { DEFAULT_THEMATIC_WATCHLISTS } from './constants';
import { fetchThematicWatchlist } from './thematicWatchlistActions';
import { createWatchlist } from './watchlistsActions';

type GetState = typeof WatchlistsStore.getState;

const initialiseWatchlist = async (id: number, dispatch: Dispatch<any>, getState: GetState) => {
  await dispatch<any>(fetchThematicWatchlist(id as number, false));
  const { name, instruments } = getState()[WATCHLISTS_STORE_NAME].thematicItems[id];
  await dispatch<any>(createWatchlist(name, instruments ?? []));
};

/**
 * @todo Remove this and make the API do the work of initialising form thematic when no watchlists exist.
 * https://cmcmarkets.atlassian.net/browse/SBCI-3996
 */
export const initialiseWatchlistsFromThematic = () => {
  return async (dispatch: Dispatch<any>, getState: GetState) => {
    try {
      const watchlists = getState()[WATCHLISTS_STORE_NAME].lists;
      if (watchlists?.length === 0) {
        await Promise.all(DEFAULT_THEMATIC_WATCHLISTS.map((id) => initialiseWatchlist(id, dispatch, getState)));
      }
    } catch {}
  };
};
